<template>
  <sidebar-menu :menu="menu">
  <span slot="dropdown-icon"><i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>
  </span>
  </sidebar-menu>
</template>
      <script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'sidebaradvance', 
  data: function() {
    return {
      name: 'sidebaradvance',
    data: [],
   isHidden: true,
     menu: []
    }
  },
  created: function() {
      var userdata = localStorage.getItem('userData');
      var userInfo = JSON.parse(userdata);
        // if (userInfo.body.length > 0 && userInfo.body[3].title === 'Adhoc Requests') {
        //     // Update href and remove child array
        //     userInfo.body[3].href = '/adhocpendingrequest';
        //     delete userInfo.body[3].child;
        // }
        const item = userInfo.body.find(item => item.title === 'Adhoc Requests');

            // Update href and remove child array
            if (item) {
                item.href = '/adhocpendingrequest';
                delete item.child;
            }
      this.menu  = userInfo.body;
  },
   methods: {
        checkCurrentRouteAndRedirect:function(router, path) {
            const {
                currentRoute: { path: curPath }
            } = router;
            if (curPath !== path) router.push({ path });
        },
    },
};
</script>
<style type="text/css">
/* ================= Sidebar Base ================= */
.v-sidebar-menu {
    background-color: #00c0ef !important; /* Main sidebar background */
    max-width: 220px !important;
    top: 50px !important;
    border: none !important;
    left: unset !important;
    font-family: "Segoe UI", Arial, sans-serif;
}

/* ================= Main Menu (Level 1) ================= */
.v-sidebar-menu .vsm--link_level-1 {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    font-size: 15px !important;
    font-weight: 500 !important;
    color: #fff !important;
    transition: all 0.3s ease;
}

/* Icons */
.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
    width: 22px !important;
    height: 22px !important;
    margin-right: 10px !important;
    text-align: center;
    line-height: 22px;
    font-size: 16px;
    color: #fff !important;
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
}

/* Hover + Active */
.v-sidebar-menu .vsm--link_level-1:hover,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {
    background-color: #f09642 !important;
    color: #fff !important;
}

/* ================= Dropdown (Submenu Container) ================= */
.v-sidebar-menu .vsm--dropdown .vsm--list {
    background-color: #e5f7fc !important;
    padding: 5px 0;
    border: none !important;
}
.v-sidebar-menu .vsm--link_level-2 {
    display: block;
    padding: 8px 25px;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #333 !important;
    transition: all 0.3s ease;
    border-bottom: 1px solid #d6d6d6; /* Divider line */
}

/* Remove border from last submenu item */
.v-sidebar-menu .vsm--list .vsm--item:last-child .vsm--link_level-2 {
    border-bottom: none;
}

.v-sidebar-menu .vsm--link_level-2:hover,
.v-sidebar-menu .vsm--link_level-2.vsm--link_active {
    background-color: #f09642 !important;
    color: #fff !important;
}

/* ================= Arrows ================= */
.v-sidebar-menu .vsm--arrow {
    font-size: 14px;
}

/* ================= Toggle Button ================= */
.v-sidebar-menu .vsm--toggle-btn {
    background-color: #00c0ef !important;
    color: #fff !important;
    border-radius: 0 !important;
    padding: 8px;
    transition: 0.3s;
}
.v-sidebar-menu .vsm--toggle-btn:hover {
    background-color: #0097b3 !important;
}

/* ================= Expanded State ================= */
.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    background-color: #00c0ef !important;
    color: #fff !important;
}

/* ================= Mobile Responsive ================= */
@media (max-width: 768px) {
    
    .v-sidebar-menu .vsm--item {
        width: 100%;
        white-space: nowrap;
    }
}

</style>